import Vue from 'vue'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_ACCOUNTGROUPS,
  RECEIVING_ACCOUNTGROUPS,
  RECEIVE_ACCOUNTGROUP_METADATA,
  RECEIVE_ACCOUNTGROUP_FAILURE,
  SAVING_ACCOUNTGROUP,
  SAVING_ACCOUNTGROUP_FAILURE,
  UPDATING_ACCOUNTGROUP,
  UPDATING_ACCOUNTGROUP_FAILURE,
  DELETE_ACCOUNTGROUP,
  DELETING_ACCOUNTGROUP,
  DELETING_ACCOUNTGROUP_FAILURE,
  CLEAR_ACCOUNTGROUP_STATE,
  RESET_ACCOUNTGROUP_META,
  CLEAR_STATE,
  INCREMENT_ACCOUNTGROUP_COUNT
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import handleXHRError from '@/utils/helpers/HandleXHRError'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const accountgroupSchema = new schema.Entity('accountgroups')
const accountgroupListSchema = new schema.Array(accountgroupSchema)

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  saveFailure: null,
  receivingData: false,
  receiveDataFailure: false,
  updating: null,
  updateFailure: null,
  deleting: false,
  deleteFailure: null
}

const actions = {
  fetchAccountgroupsWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_ACCOUNTGROUPS, true)
    return Vue.http.get(buildUrlWithQuery('accountgroups', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_ACCOUNTGROUPS, false)
        this.commit(RESET_ACCOUNTGROUP_META)
        if (r.hasOwnProperty('results')) {
          const { results, next, previous, count } = r
          const { entities, result } = normalize(results, accountgroupListSchema)
          this.commit(RECEIVE_ACCOUNTGROUPS, { data: entities.accountgroups })
          this.commit(RECEIVE_ACCOUNTGROUP_METADATA, { next, previous, count, result: result.length })
          return { query, count, entities }
        }
      })
      .catch(e => {
        this.commit(RECEIVING_ACCOUNTGROUPS, false)
        this.commit(RECEIVE_ACCOUNTGROUP_FAILURE, handleXHRError(e))
      })
  }
}

const getters = {
  getAccountgroups: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllAccountgroups: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getAccountgroupMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getAccountgroupById: (state) => (id) => {
    return state.cache && state.cache[id] ? state.cache[id] : {}
  },
  getAccountgroupFetchStatus: (state) => {
    return state.receivingData
  },
  getAccountgroupSaveStatus: (state) => {
    return state.saving
  },
  getAccountgroupUpdateStatus: (state) => {
    return state.updating
  },
  getAccountgroupDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_ACCOUNTGROUPS] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_ACCOUNTGROUPS] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_ACCOUNTGROUP_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [SAVING_ACCOUNTGROUP] (state, payload) {
    state.saving = payload
  },
  [SAVING_ACCOUNTGROUP_FAILURE] (state, payload) {
    state.saveFailure = payload
  },
  [UPDATING_ACCOUNTGROUP] (state, payload) {
    state.updating = payload
  },
  [UPDATING_ACCOUNTGROUP_FAILURE] (state, payload) {
    const { id, err } = payload
    state.updateFailure = { id, err }
  },
  [DELETE_ACCOUNTGROUP] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_ACCOUNTGROUP] (state, payload) {
    state.deleting = payload
  },
  [DELETING_ACCOUNTGROUP_FAILURE] (state, payload) {
    const { id, err } = payload
    state.deleting = { id, err }
  },
  [INCREMENT_ACCOUNTGROUP_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_ACCOUNTGROUP_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_ACCOUNTGROUP_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_ACCOUNTGROUP_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/accountGroup.js